import "../../global.css";
import "./campaignList.css";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { userRequest } from "../../requestMethods";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { formatTimeDDMMYYY } from "../../util/helper";
import { DeleteOutline } from "@mui/icons-material";
import { useCompany } from "../../components/context/CompanyContext";
import Swal from "sweetalert2";
import { titleSetRef } from "../../redux/titleRedux";
import { useDispatch, useSelector } from "react-redux";
import CustomGrid from "../../components/grid/CustomGrid";

export default function CampaignList() {
  const [campaigns, setCampaigns] = useState([{}]);
  const { companyId } = useCompany();
  const currentUser = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(titleSetRef({ title: "Campanha" }));
    if (companyId > 0) {
      getCampaigns();
    }
  }, [companyId]);

  const getCampaigns = async () => {
    try {
      const res = await userRequest.get(`${companyId}/campaign`);

      setCampaigns(
        res.data.map((item) => ({
          campaignId: item.campaignId,
          title: item.title,
          subTitle: item.subTitle,
          products: item.products.length,
          expiryDate: item.expiryDate,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  };
  const onButtonEditarClick = (e, row) => {
    nav(`${row}`);
  };
  const deleteCp = async (cp, del) => {
    let delToogle = { deleted: null };
    if (del) {
      delToogle = { deleted: new Date(), lastUserUpdate: currentUser.userId };
    }

    const res = await userRequest.delete(`${companyId}/campaign/${cp}`);

    if (res.data > 0) {
      getCampaigns();
    } else {
      Swal.fire("Atenção!", "Erro ao inativar campanha!", "error");
    }
  };
  const onButtonDeleteClick = (e, row) => {
    if (currentUser.isAdmin) {
      if (!e.target.checked) {
        Swal.fire({
          title: "Tem certeza que deseja excluir?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#EE8253",
          confirmButtonText: "Sim, excluir!",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            deleteCp(row, true);
          } else {
            getCampaigns();
          }
        });
      } else {
        deleteCp(row, false);
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para inativar usuário!",
        "warning",
      );
    }
  };
  const columns = [
    {
      field: "campaignId",
      type: "number",
      headerName: "ID Camapanha",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      hide: false,
    },
    {
      field: "action",
      type: "text",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      display: "flex",
      renderCell: (params) => {
        return (
          <>
            <IconButton
              onClick={(e) => onButtonEditarClick(e, params.row.campaignId)}
            >
              <EditIcon />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "title",
      type: "text",
      align: "left",
      headerName: "Campanha",
      width: 200,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "products",
      type: "number",
      headerName: "Qtde Produtos",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "expiryDate",
      type: "date",
      headerName: "Expira em",
      width: 150,
      align: "left",
      headerClassName: "dataGridMuiHeader",
      format: "dd/MM/yyyy HH:mm:ss",
    },
    {
      field: "createdAt",
      type: "date",
      headerName: "Criada em",
      width: 150,
      align: "left",
      headerClassName: "dataGridMuiHeader",
      format: "dd/MM/yyyy HH:mm:ss",
    },
    {
      field: "updatedAt",
      type: "date",
      headerName: "Atualizada em",
      width: 150,
      align: "left",
      headerClassName: "dataGridMuiHeader",
      format: "dd/MM/yyyy HH:mm:ss",
    },
    {
      field: "deletar",
      type: "text",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={(e) => onButtonDeleteClick(e, params.row.campaignId)}
          >
            <DeleteOutline />
          </IconButton>
        );
      },
    },
  ];

  const nav = useNavigate();
  const addRow = () => {
    nav(`new`);
  };

  return (
    <div className="cust-page">
      <div className="cust-title">Campanhas</div>
      <div className="cust-card">
        <div className="cust-section-header">Lista de Campanhas</div>
        <div style={{ padding: "16px" }}>
          <CustomGrid
            toolbarActions={
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddIcon />}
                onClick={addRow}
                size="small"
              >
                Adicionar Campanha
              </Button>
            }
            gridId="campaignList"
            rows={campaigns}
            columns={columns}
            pageSize={45}
            checkboxSelection={false}
          />
        </div>
      </div>
    </div>
  );
}
